financeModule.controller('financeCalculatorController', [
    '$scope', 'financeService','TLCError', '$mdDialog',
    function($scope, financeService, TLCError, $mdDialog) {

        // controller perspective is that these are products.  But there is quote info here as well.
        $scope.financeProducts = null;
        var originalAcceptanceByQuoteId = null;

        $scope.init = function(){
            $scope.financeProducts = financeService.quotesToCalc;
            if ($scope.financeProducts && $scope.financeProducts.length > 0){
                activeProductView = $scope.financeProducts[0].productName;
                originalAcceptanceByQuoteId = _.object($scope.financeProducts.map(function(product) { return [ product.quoteId, product.financingInfo.accepted ]; }));
            }else{
                $mdDialog.hide();//no products to do alt finance.. close it
            }
        }


        var activeProductView = '';
        $scope.setActiveView = function(viewName) {
            activeProductView = viewName;
        };
        $scope.isViewActive = function(viewName) {
            return viewName === activeProductView;
        };

        $scope.calculatePayments = function(product) {
                if(product.financingInfo.salesTaxNA)
                product.financingInfo.salesTaxAmount = 0;

            financeService.calculateFinancing(product)
                .then(function() {
                    product.calculationFinshed = true;
                }, function(err) {
                    $scope.error = { reason : err.reason};
                    $scope.financeProducts[0].financingInfo.eligibleTerms = err.terms;
                    $scope.financeProducts[0].financingInfo.selectedPaymentTerm = null;
                });
        };

        $scope.onFinish = function() {
            $mdDialog.hide();
        }

        $scope.onCancel = function() {
            financeService.quotesToCalc=[];
            $scope.financeProducts.forEach(function(product) {
                // put acceptance back to its initial state prior to any user actions in calculator.
                // This will trigger a save if anything changed.
                product.financingInfo.accepted = originalAcceptanceByQuoteId[product.quoteId];
            });
            $mdDialog.hide();
        };

        $scope.allFieldsValidForProduct = function(product) {
            // this same validation already exists in the page markup as well
            // if you change it here please change it there as well
            var downPaymentValid = isDownPaymentValid(product.financingInfo.downPayment, product.cost, (product.financingInfo.salesTaxNA ? 0 : product.financingInfo.salesTaxAmount));
            var otherFieldsFilled = !!(product.financingInfo.selectedPaymentTerm && (product.financingInfo.salesTaxAmount || product.financingInfo.salesTaxNA));

            return downPaymentValid && otherFieldsFilled;
        };

        function isDownPaymentValid(downPayment, productCost, salesTaxAmount) {
            return downPayment >= ((productCost + salesTaxAmount) * 0.1).toFixed(2) && downPayment <= ((productCost + salesTaxAmount) * 0.2).toFixed(2);
        }

        $scope.isAnyProductFinancingAccepted = function() {
            return $scope.financeProducts.some(function(product) { return product.financingInfo.accepted; });
        };

        $scope.clearError = function() {
            $scope.error = {};
        };

        $scope.recheckEligibility = function(product) {
            var downPayment = product.financingInfo.downPayment;
            var productQuoteMock = {
                RatedProduct : { InternalProductId : product.productName },
                RatedTerms : [{ SavedRateUniqueId : product.quoteId }]
            };

            financeService.isProductEligible(productQuoteMock, downPayment + (product.financingInfo.salesTaxNA ? 0 : product.financingInfo.salesTaxAmount))
                .then(
                function(result) {
                    if(product.financingInfo.eligibleTerms != result.terms) {
                        if(isDownPaymentValid(downPayment, product.cost, (product.financingInfo.salesTaxNA ? 0 : product.financingInfo.salesTaxAmount)) // don't really want to put up an error msg if they haven't entered a valid downpayment yet
                            && product.financingInfo.selectedPaymentTerm // no error if no payment term selected yet
                            && result.terms.indexOf(product.financingInfo.selectedPaymentTerm) < 0) {
                            $scope.error = { reason : "The Payment term selected is not available for the amount financed."};
                            product.financingInfo.selectedPaymentTerm = null;
                        }
                        product.financingInfo.eligibleTerms = result.terms;
                    }
                },
                function(err){
                    throw new TLCError(new Error(err),AppErrorCodes.QuoteQueueController_AltFinanceError);
                }
            );
        };

        $scope.init();
    }]);
